import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_api';
import { PATH_CONTABILIZA } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { IConsultaErroRequest, Types } from './types';

// ACTIONS
import { consultaErroFailure, consultaErroSuccess } from './actions';

function* consultaErro(request: ReducerAction) {
	const { payload }: { payload: IConsultaErroRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		PATH_CONTABILIZA,
		'contabilizacoes-erro',
		payload,
	);

	if (response.status === 200) {
		yield put(consultaErroSuccess(response.data));
	} else if (response.error) {
		yield put(consultaErroFailure(response.message));
	}
}

export default all([takeLatest(Types.CONSULTA_ERRO, consultaErro)]);
